export async function createFileArchive(files: readonly { name: string; blob: Blob }[]) {
  const { default: JSZip } = await import("jszip")
  const archive = new JSZip()
  const names = new Set<string>()
  for (const file of files) {
    const leaf = (file.name.split(/[\\/]/).pop() || "file").replace(/[<>:"|?*\u0000-\u001f]/g, "_").normalize("NFC")
    const original = /^\.+$/.test(leaf) ? "file" : leaf
    const dot = original.lastIndexOf(".")
    const stem = dot > 0 ? original.slice(0, dot) : original
    const extension = dot > 0 ? original.slice(dot) : ""
    let name = original
    for (let suffix = 2; names.has(name.toLowerCase()); suffix++) name = `${stem} (${suffix})${extension}`
    names.add(name.toLowerCase())
    archive.file(name, await file.blob.arrayBuffer())
  }
  return archive.generateAsync({ type: "blob", compression: "STORE" })
}
